import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";

export const CreateClientService=async(data)=>{
    try {
        const result = await postfd(`api/client/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClientService=async(data,id)=>{
    try {
        const result = await postfd(`api/client/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClientService=async()=>{
    try {
        const result = await get(`api/client/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClientDetailService=async(id)=>{
    try {
        const result = await get(`api/client/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const FilterClientService=async(page,search,from_date,to_date,type)=>{
    try {
        const result = await get(`api/client/filter?page=${page}&search=${search}&from_date=${from_date}&to_date=${to_date}&type=${type}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const DeleteClientService=async(id)=>{
    try {
        const result = await deleteRequest(`api/client/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}